import ReviewModal from "components/Verification/components/ReviewModal";
import ReviewSubmitModal from "components/Verification/components/ReviewSubmitModal";
import React, { createContext, useContext, useState } from "react";

const ReviewModalContext = createContext();

export function FeedBackModelProvider({ children }) {
  const [feedBackOpen, setFeedBackOpen] = useState(false);
  const [submit, setSubmit] = useState(false);
  return (
    <ReviewModalContext.Provider value={{ feedBackOpen, setFeedBackOpen }}>
      {children}
      <ReviewModal
        open={feedBackOpen}
        setOpen={setFeedBackOpen}
        onOk={() => setSubmit(true)}
      />
      <ReviewSubmitModal open={submit} setOpen={setSubmit} />
    </ReviewModalContext.Provider>
  );
}

export function useFeedBack() {
  return useContext(ReviewModalContext);
}
